<script setup lang="ts">
import { computed } from 'vue'
import { usePreferencesStore } from '../stores/preferences'

const p = usePreferencesStore()
const show = computed(() => p.prefs.crtEnabled)
</script>

<template>
  <div v-if="show" class="crt-overlay-global" aria-hidden="true"></div>
</template>

<style scoped>
.crt-overlay-global {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 9999;
  background:
    radial-gradient(ellipse at center, transparent 0%, rgba(0, 0, 0, 0.25) 100%);
}
</style>
